module.exports = __webpack_public_path__ + "static/img/RK1564-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RK1564-G_1.png
// module id = 13rs
// module chunks = 0